import { sortAlphabetically } from './sortUtil';
import { ADWORDS_DISPLAY_NAME } from './reportsConsts';
import { TWITTER_PARTNER_NAME } from '../partnerConfiguration/consts';

export const NETWORKS_SPECIAL_DISPLAY_NAME_MAPPING = {
    adwords: ADWORDS_DISPLAY_NAME,
    doubleclickdcm: 'Double Click DCM (Google - CM360)',
    doubleclickdbm: 'Double Click DBM (Google - DVI360)',
    searchads360: 'Search Ads 360 (Google - SA360)',
    verizon: 'Verizon Media (Yahoo DSP)',
    aarki: 'RZR (Aarki)',
    yahoo_japan_ydn: 'LY Ads (Yahoo Japan)',
};

export const NETWORKS_SPECIAL_ORIGINAL_DISPLAY_NAME_MAPPING = {
    adwords: 'AdWords',
    doubleclickdcm: 'Double Click DCM',
    doubleclickdbm: 'Double Click DBM',
    searchads360: 'Search Ads 360',
    verizon: 'Verizon Media',
    aarki: 'Aarki',
    yahoo_japan_ydn: 'Yahoo Japan (YDN)',
};

export const getAdnetworkDisplayName = (name, displayName) =>
    NETWORKS_SPECIAL_DISPLAY_NAME_MAPPING[name] || displayName?.trim();

const formatAdNetworkObject = (id, name, displayName, logoPath, disabled) => ({
    id,
    value: name,
    logoPath,
    label: getAdnetworkDisplayName(name, displayName),
    isDisabled: disabled,
});

export const getAdNetworkOptions = adNetworks => {
    return Object.keys(adNetworks)
        .map(key => {
            const adNetwork = adNetworks[key];
            return formatAdNetworkObject(
                adNetwork.id,
                adNetwork.name,
                adNetwork.display_name,
                adNetwork.logo_path,
                adNetwork.disabled
            );
        })
        .sort(({ label: label1 }, { label: label2 }) => sortAlphabetically(label1, label2))
        .sort(a => (a.isDisabled ? 1 : -1));
};

export const getPartnersOptions = partners => {
    return partners
        .map(({ id, name, displayName, logoPath }) => formatAdNetworkObject(id, name, displayName, logoPath))
        .sort(({ label: label1 }, { label: label2 }) => sortAlphabetically(label1, label2));
};

export const getUseNewShelfOption = (organizationOptions, partner) => {
    const { newPartnerConfigShelf = false, newAccountPartnerConfigShelf = false } = organizationOptions || {};
    // this flow is temporary and will be removed once all clients will be migrated to new account partner shelf
    return partner.name !== TWITTER_PARTNER_NAME
        ? newPartnerConfigShelf && partner.options.new_partner_config_shelf !== false
        : newAccountPartnerConfigShelf && partner.options.new_partner_config_shelf !== false;
};
